module.exports = __webpack_public_path__ + "img/main.944c8303.jpg";